import React from 'react';

function NatsteelMobile() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='35.245'
      height='17.566'
      viewBox='0 0 35.245 17.566'
    >
      <g fill='#fff' data-name='Group 13439' transform='translate(-37.669 -1.908)'>
        <path
          d='M214.516 93.429l1.533-2.37c.244-.379.476-.765.728-1.138a.352.352 0 01.245-.142q10.04-.009 20.08-.005c.024 0 .049.006.1.014a1.63 1.63 0 01-.082.172c-.7 1.108-1.409 2.213-2.1 3.325a.379.379 0 01-.375.2q-10.065-.007-20.129 0z'
          data-name='Path 609'
          transform='translate(-176.847 -74.009)'
        />
        <path
          d='M308.678 10.877c-.122.214-.221.406-.336.587-.61.961-1.225 1.918-1.835 2.878a.455.455 0 01-.438.232q-9.893-.012-19.786-.006h-.3a1.493 1.493 0 01.075-.158c.716-1.129 1.431-2.258 2.157-3.381a.4.4 0 01.289-.158q9.98-.011 19.96-.006c.055 0 .111.006.214.012'
          data-name='Path 610'
          transform='translate(-235.764 -8.957)'
        />
        <path
          d='M291.831 37.312c-.142.235-.269.458-.407.673-.612.956-1.23 1.908-1.838 2.866a.323.323 0 01-.319.166c-.983-.007-1.967 0-2.95 0h-17.2c.061-.113.1-.2.156-.288q1.042-1.64 2.092-3.275a.346.346 0 01.242-.144q10.053-.01 20.105-.005c.025 0 .049 0 .114.011'
          data-name='Path 611'
          transform='translate(-221.863 -30.75)'
        />
        <path
          d='M253.889 63.506c-.4.634-.779 1.237-1.16 1.837-.343.54-.7 1.071-1.027 1.62a.469.469 0 01-.473.25q-9.866-.008-19.732 0h-.337c.294-.46.562-.879.828-1.3q.711-1.122 1.419-2.245a.3.3 0 01.288-.172q10.027.008 20.054.005c.033 0 .065 0 .141.008'
          data-name='Path 612'
          transform='translate(-190.567 -52.344)'
        />
      </g>
    </svg>
  );
}

export default NatsteelMobile;
